import {
  GET_NEW_CLIENTS,
  GET_NEW_CLIENTS_SUCCESS,
  GET_NEW_CLIENTS_FAIL,
  GET_SELECTED_NEW_CLIENTS,
  GET_SELECTED_NEW_CLIENTS_SUCCESS,
  GET_SELECTED_NEW_CLIENTS_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL NEW CLIENTS
export const getNewClients = () => ({
  type: GET_NEW_CLIENTS,
})
export const getNewClientsSuccess = (clients) => ({
  type: GET_NEW_CLIENTS_SUCCESS,
  payload: clients
});
export const getNewClientsFail = (error) => ({
  type: GET_NEW_CLIENTS_FAIL,
  payload: error
});

// GET SELECTED MANAGER NEW CLIENTS
export const getSelectedNewClients = (id) => ({
  type: GET_SELECTED_NEW_CLIENTS,
  payload: id
})
export const getSelectedNewClientsSuccess = (clients) => ({
  type: GET_SELECTED_NEW_CLIENTS_SUCCESS,
  payload: clients
});
export const getSelectedNewClientsFail = (error) => ({
  type: GET_SELECTED_NEW_CLIENTS_FAIL,
  payload: error
});

// DISPLAY LOADING ICON
export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})